import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Heading } from '@printdeal/ui-library';
import ModalContentLogin from '../../authentication/login-modal/ModalContentLogin';
import ModalContentLostPassword from '../../authentication/login-modal/ModalContentLostPassword';

interface StaticLoginBoxProps {
  userType?: {
    isEnduser?: boolean;
    isReseller?: boolean;
  };
}

const StaticLoginBox = ({ userType }: StaticLoginBoxProps) => {
  const [modalView, setModalView] = useState('login');

  return (
    <div className="pd-h-full">
      <Container size="md" className="pd-h-full pd-rounded pd-bg-dim-100 pd-p-5">
        <Heading as="div" size="2" className="pd-mb-5 pd-text-dim-800">
          <FormattedMessage
            id="login.slideout.loginTitle"
            defaultMessage="Log into your account"
          />
        </Heading>

        {modalView === 'login' ? (
          <ModalContentLogin
            setModalView={setModalView}
            userType={userType}
          />
        ) : (
          <ModalContentLostPassword setModalView={setModalView} />
        )}
      </Container>
    </div>
  );
};

export default StaticLoginBox;
